import React from "react";
import { getBlogDisplayDates } from "../../helpers/blogDates";

// Cards have room for one date: the last update when there is one, else the
// publish date. The post page itself shows both.
export const BlogCardDate = ({
  post,
}: {
  post: { publishedDate: string; updated?: string | Date; updatedAt?: string };
}) => {
  const { primary } = getBlogDisplayDates(post);
  return (
    <time dateTime={primary.iso}>
      {" "}
      {primary.isUpdate && "Updated "}
      {primary.label}
    </time>
  );
};
